import React, {ChangeEvent, FC} from "react";
import styles from "./FormInput.module.scss";
import cn from "classnames";
import {FormInputProps} from "./types";
import {TSelect} from "../Select/types";
import Select from "../Select";
import PhoneInput from "../PhoneInput";

const FormInput: FC<FormInputProps> = ({
                                           label,
                                           placeholder,
                                           value,
                                           setValue,
                                           errorMessage,
                                           type,
                                           required = false,
                                           disabled = false,
                                           isReadOnly = false,
                                           options,
                                           className,
                                           onKeyUp,
                                           ...props
                                       }) => {
    const onChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const inputValue = e.target.value;

        if (type !== "number") {
            setValue(inputValue);
        } else if (inputValue === ".") {
            setValue("0.");
        } else if (/^-?\d*\.?\d*$/.test(inputValue)) {
            setValue(inputValue);
        }
    };

    const renderInput = () => {
        if (type === "select") {
            const selectedOptions = options as TSelect[] | undefined;
            const selected = options?.length && typeof options[0] !== "string"
                ? selectedOptions?.find(item => item.value === value?.toString())
                : value?.toString();
            return (
                <Select
                    label={placeholder || ""}
                    selected={selected}
                    className={cn(styles.select, {[styles.error]: errorMessage})}
                    setSelected={selectedValue => setValue(typeof selectedValue === "string" ? selectedValue : selectedValue?.value || "")}
                    options={options}
                />
            );
        } else if (type === "phone") {
            return (
                <PhoneInput
                    id={label}
                    value={value?.toString()}
                    onChange={phone => setValue(phone || "")}
                    error={!!errorMessage}
                    placeholder={placeholder}
                />
            );
        } else if (type === "textarea") {
            return <textarea value={value}
                             onChange={onChange}
                             placeholder={placeholder}
                             disabled={disabled}
                             className={cn({[styles.error]: errorMessage})}
                             id={label}/>;
        } else {
            const inputType = type === "text" || type === "number" ? "text" : type;
            return (
                <input
                    type={inputType}
                    id={label}
                    readOnly={isReadOnly}
                    className={cn({[styles.error]: errorMessage})}
                    disabled={disabled}
                    placeholder={placeholder}
                    value={value}
                    onKeyUp={onKeyUp}
                    onChange={onChange}
                />
            );
        }
    };

    return (
        <div className={cn(styles.formInput, className)} {...props}>
            <label htmlFor={label}>
                {label}
                {required && <sup>*</sup>}
            </label>
            {renderInput()}
            {errorMessage && <span>{errorMessage}</span>}
        </div>
    );
};

export default FormInput;
